// extracted by mini-css-extract-plugin
export default {"files-pagination":"FilesPagination_files-pagination__6Cjya"};